import { ReactNode, useEffect } from "react";
import { useOutletContext } from "react-router-dom";

import { IntegrationsOutletContext } from "../types";

export const useLayoutNavigation = (navigationItems: ReactNode) => {
  const { setLayoutNavigation } = useOutletContext<IntegrationsOutletContext>();

  useEffect(() => {
    if (!navigationItems) {
      setLayoutNavigation(null);
    } else {
      setLayoutNavigation(navigationItems);
    }

    return () => {
      setLayoutNavigation(null);
    };
  }, [navigationItems, setLayoutNavigation]);
};
